export class GlobalTax {
  id: number;
  name: string;
  amount: number = 0.0;
  frequency: string;
  way: string;
  cutoff: number = 0.0;
  name_str: string;
}
